import { TriangleAlert } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface FormFieldWithErrorProps {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
}

export function FormFieldWithError({
  id,
  label,
  type,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
}: FormFieldWithErrorProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        name={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`bg-white dark:bg-muted ${
          error
            ? 'border-destructive focus:border-destructive focus:ring-destructive'
            : ''
        }`}
        disabled={disabled}
      />
      {error && (
        <p className="text-sm text-destructive flex items-center gap-1">
          <TriangleAlert className="size-3" />
          {error}
        </p>
      )}
    </div>
  );
}
